export const selectBrand = state => state?.brand?.data;
export const selectIsErrorBrand = state => state?.brand?.isErrorBranding;
export const selectBrandLoadingState = state => state?.brand?.loading;
export const selectBrandName = state => state?.brand?.data?.name;
export const selectBrandLogoUrl = state => state?.brand?.data?.logoBase64;
export const selectBrandFullLogoUrl = state => state?.brand?.data?.fullLogoUrl;
export const selectBrandColor = state => state?.brand?.data?.color;
export const selectBrandingColors = state => state?.brand?.data?.branding?.colors;
